import { Button } from "primereact/button";
import { useForm } from 'react-hook-form';
import { useEffect, useState } from "react";
import { Fetch } from "../../shared/Fetch";
import { JVInput } from "../../shared/JVInput";
import { JVDropdown } from "../../shared/JVDropdown";
import { JVDate } from "../../shared/JVDate";
import { IBranchMastDropdown, IClientCompanyDropdown, ICompanyMastDropdown, ISkillCategoriesDropdown, ISubmissionStatusDropdown, ITeamsDropdown, IUsersDropdown } from "../../models/IDropdown";
import { JVDropdownInput } from "../../shared/JVDropdownInput";
import { Dropdown } from "primereact/dropdown";
import { ILogin } from "../../models/Login";
import { MultiSelect } from "primereact/multiselect";
import { client_Type } from "../../models/FDropdown";

export interface IPipelineFilter {
    fromDate?: Date | null,
    toDate?: Date | null,
    req_EndClient?: string | null,
    vendor_Company_ID?: number | null,
    vendor_Company?: IClientCompanyDropdown,
    subVendorID?: number | null,
    subVendor?: IClientCompanyDropdown,
    req_ID?: number | null | string,
    recruiter_ID?: number | null,
    status_Name?: string | null,
    team?: number | null,
    sm?: number | null,
    company?: number | null,
    branch?: number[] | null,
    companyType?: string | null,
    req_Category?: number | null,
    Consultant_Name?: string | null,
}

export const EmptyFilter: IPipelineFilter = {
    fromDate: new Date,
    toDate: new Date,
    req_EndClient: "",
    vendor_Company_ID: null,
    vendor_Company: { vendor_Company_ID: 0, vendor_Company_Name: "" },
    subVendorID: null,
    subVendor: { vendor_Company_ID: 0, vendor_Company_Name: "" },
    req_ID: "",
    recruiter_ID: null,
    status_Name: null,
    team: null,
    sm: null,
    company: null,
    branch: null,
    companyType: null,
    req_Category: null,
    Consultant_Name: "",
}

interface Iprops {
    plFilter: IPipelineFilter,
    setPLFilter: (plFilter: IPipelineFilter) => void
}

export const Filter = (props: Iprops) => {
    const [recruiters, setRecruiters] = useState<Array<IUsersDropdown>>();
    const [clientCompanies, setClientCompanies] = useState<Array<IClientCompanyDropdown>>();
    const [subVendorCompanies, setsubVendorCompanies] = useState<Array<IClientCompanyDropdown>>();
    const [submissionStatus, setSubmissionStatus] = useState<Array<ISubmissionStatusDropdown>>();
    const [team, setTeam] = useState<Array<ITeamsDropdown>>();
    const [sm, setSM] = useState<Array<IUsersDropdown>>();
    const [company, setCompany] = useState<Array<ICompanyMastDropdown>>();
    const [type, setType] = useState<Array<any>>();
    const [branch, setBranch] = useState<Array<IBranchMastDropdown>>();
    const [skillCategories, setSkillCategories] = useState<Array<ISkillCategoriesDropdown>>();
    const [selectedSm, setselectedSm] = useState<any | null>(null);
    const [selectedRecruiter, setSelectedRecruiter] = useState<any | null>(null);
    const [selectedBranch, setSelectedBranch] = useState<Array<number>>([]);

    const _roles: Array<number> = [];
    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    loginObj.roles.forEach(role => {
        _roles.push(role.role_ID);
    });

    const LitencyType = [
        { litency_Type: '0-45' },
        { litency_Type: '46-90' },
        { litency_Type: '91-120' },
        { litency_Type: '120+' },
    ]

    const { control, handleSubmit, reset, watch } = useForm<IPipelineFilter>({
        defaultValues: props.plFilter,
        shouldFocusError: false
    });

    const loadRecruiters = async (branch: number[] | null | undefined, company: number | null | undefined, team: number | null | undefined) => {
        let queryParameter = null;
        if (team != 0 && team != null) {
            queryParameter = `team_ID=${team}`;
        } else if (branch && branch.length > 0 && branch[0] != 0) {
            // queryParameter = `branch_ID=${branch}`;
            queryParameter = branch.map(b => `branch_ID=${b}`).join("&");
        } else if (company != 0 && company != null) {
            queryParameter = `company_ID=${company}`;
        }

        const response = await Fetch("Dropdown/filterUsersListss", "GET", null, `user_Type=recruiter&${queryParameter}`, null);
        if (response) {
            const data: Array<IUsersDropdown> = await response.json();
            const emptyData = {
                login_ID: 0,
                user_Name: "-- SELECT --"
            };
            data.unshift(emptyData);
            setRecruiters(data);
        }
    }
    const loadSm = async (branch: number[] | null | undefined, company: number | null | undefined, team: number | null | undefined) => {
        let queryParameter = null;
        if (team != 0 && team != null) {
            queryParameter = `team_ID=${team}`;
        } else if (branch && branch.length > 0 && branch[0] != 0) {
            // queryParameter = `branch_ID=${branch}`;
            queryParameter = branch.map(b => `branch_ID=${b}`).join("&");

        } else if (company != 0 && company != null) {
            queryParameter = `company_ID=${company}`;
        }

        const response = await Fetch("Dropdown/filterUsersListss", "GET", null, queryParameter, null);
        if (response) {
            const data: Array<IUsersDropdown> = await response.json();
            const emptyData = {
                login_ID: 0,
                user_Name: "-- SELECT --"
            };
            data.unshift(emptyData);
            setSM(data);
        }
    }
    const loadTeam = async (branch: number[] | null | undefined, company: number | null | undefined, type?: string) => {
        let queryParameter = null;
        if (branch && branch.length > 0 && branch[0] != 0) {
            queryParameter = branch.map(b => `branch_ID=${b}`).join("&");
        } else if (company != 0 && company != null) {
            queryParameter = `company_ID=${company}`;
        }

        if (type && type != "" && type != "-- SELECT --") {
            if (type === "sales") queryParameter = "user_Type=sales&" + queryParameter;
            if (type === "recruiter") queryParameter = "user_Type=recruiter&" + queryParameter;
        }

        const response = await Fetch("Dropdown/filterTeamsList", "GET", null, queryParameter, null);
        if (response) {
            const data: Array<ITeamsDropdown> = await response.json();
            const emptyData = {
                team_ID: 0,
                team_Name: "-- SELECT --"
            };
            data.unshift(emptyData);
            setTeam(data);
        }
    }


    const loadSkillCategories = async () => {
        const response = await Fetch("Dropdown/skillsCategories", "GET", null, null, null);
        if (response) {
            const data: Array<ISkillCategoriesDropdown> = await response.json();
            const emptyData = {
                req_CategoryID: 0,
                req_CategoryName: "-- SELECT --",
            };
            data.unshift(emptyData);
            setSkillCategories(data);
        }
    }

    const loadSubmissionStatus = async () => {
        const response = await Fetch("Dropdown/submissionStatus", "GET", null, null, null);
        if (response) {
            const data: Array<ISubmissionStatusDropdown> = await response.json();
            const emptyData = {
                status_ID: 0,
                status_Name: "-- SELECT --"
            };
            data.unshift(emptyData);
            setSubmissionStatus(data);
        }
    }

    const loadCompany = async () => {
        const response = await Fetch("Dropdown/reqCompanyList", "GET", null, null, null);
        if (response) {
            const data: Array<ICompanyMastDropdown> = await response.json();
            const emptyData = {
                company_ID: 0,
                company_Name: "-- SELECT --"
            };
            data.unshift(emptyData);
            setCompany(data);
        }
    }
    const loadBranch = async (company?: number | null | undefined) => {
        let queryParam = company ? `company_id=${company}` : null;
        const response = await Fetch("Dropdown/filterBranchList", "GET", null, queryParam, null);
        if (response) {
            const data: Array<IBranchMastDropdown> = await response.json();
            const emptyData = {
                branch_ID: 0,
                branchName: "-- SELECT --",
                company_ID: 0
            };
            data.unshift(emptyData);
            setBranch(data);
        }
    }
    const loadType = () => {

        const data = [
            {
                type_Name: "-- SELECT --"
            },
            {
                type_Name: "sales"
            },
            {
                type_Name: "recruiter"
            }]
        setType(data);
    }

    const loadClientCompanies = async (filter: string | null) => {
        const response = await Fetch("Dropdown/vendor_companies", "GET", null, `filter=${filter}`, null);
        if (response) {
            const data: Array<IClientCompanyDropdown> = await response.json();
            setClientCompanies(data);
        }
    }

    const loadsubClientCompanies = async (filter: string | null) => {
        const response = await Fetch("Dropdown/sub_vendor_companies", "GET", null, `filter=${filter}`, null);
        if (response) {
            const data: Array<IClientCompanyDropdown> = await response.json();
            setsubVendorCompanies(data);
        }
    }

    const completeMethodEC = (event: { query: string }) => {
        loadClientCompanies(event.query);
    }

    const completeMethodSubVendor = (event: { query: string }) => {
        loadsubClientCompanies(event.query);
    }

    useEffect(() => {
        const subscription = watch((value, { name, type }) => {
            if (name === "companyType") {
                if (value.companyType === "recruiter" && value.companyType != null) {

                    loadTeam(control._formValues.branch, control._formValues.company, "recruiter");
                } else if (value.companyType === "sales" && value.companyType != null) {

                    loadTeam(control._formValues.branch, control._formValues.company, "sales");
                } else {

                    if (value.companyType != null) {
                        loadTeam(control._formValues.branch, control._formValues.company, "");
                    }
                }
            }

            if (name === "company") {
                if (value.company != 0 && value.company != null) {
                    loadTeam([], value.company);
                    loadSm([], value.company, 0);
                    loadBranch(value.company);
                } else {
                    if (value.company === 0 && value.company != null) {
                        loadBranch();
                        loadTeam(control._formValues.branch, value.company);
                        loadRecruiters(control._formValues.branch, value.company, control._formValues.team);
                        loadSm(control._formValues.branch, value.company, control._formValues.team);
                    }
                }
            }

            if (name === "branch") {
                if (selectedBranch.length > 0 && value.branch != null) {
                    // loadTeam(selectedBranch, 0);
                    // loadSm(selectedBranch, 0, 0);
                    // loadRecruiters(selectedBranch, 0, 0);
                } else {
                    if (selectedBranch.length > 0 && value.branch != null) {
                        // loadTeam(selectedBranch, control._formValues.company);
                        // loadRecruiters(selectedBranch, control._formValues.company, control._formValues.team);
                        // loadSm(selectedBranch, control._formValues.company, control._formValues.team);
                    }
                }
            }

            if (name === "team") {
                if (value.team != 0 && value.team != null) {
                    loadSm([], 0, value.team);
                    loadRecruiters([], 0, value.team);
                } else {
                    if (value.team === 0 && value.team != null) {
                        loadRecruiters(control._formValues.branch, control._formValues.company, value.team);
                        loadSm(control._formValues.branch, control._formValues.company, value.team);
                    }
                }
            }
        });

        return () => subscription.unsubscribe();
    }, [watch]);

    useEffect(() => {
        loadTeam([], 0);
        loadRecruiters([], 0, 0);
        loadSm([], 0, 0);
        loadSubmissionStatus();
        loadType();
        loadBranch();
        loadCompany();
        loadSkillCategories();
    }, []);

    const searchToDB = async (body: IPipelineFilter) => {
        // onHide();
        let filterData: any = body;
        let emptyFilter: any = EmptyFilter;
        for (let key in filterData) {
            if (filterData[key] === "-- SELECT --" || filterData[key] === 0) {
                filterData[key] = emptyFilter[key];
            }
        }
        body = filterData;
        props.setPLFilter(body);
    }

    function onSubmit(data: IPipelineFilter) {
        data.sm = selectedSm;
        data.recruiter_ID = selectedRecruiter
        if (selectedBranch.length > 0) data.branch = selectedBranch
        if (data.vendor_Company?.vendor_Company_ID) data.vendor_Company_ID = data.vendor_Company?.vendor_Company_ID;
        if (data.subVendor?.vendor_Company_ID) data.subVendorID = data.subVendor?.vendor_Company_ID;
        delete data.vendor_Company;
        delete data.subVendor;
        searchToDB(data);
    }

    useEffect(() => {
        if (selectedBranch.length > 0) {
            console.log("Selected Branches:", selectedBranch);
            loadTeam(selectedBranch, 0); // Assuming loadTeam takes a single branch
            loadRecruiters(selectedBranch, 0, 0);
            // Pass the entire array
            loadSm(selectedBranch, 0, 0);

        }

    }, [selectedBranch]);

    // const onHide = () => {
    //     props.hideDialog();
    // }
    const onClear = () => {
        reset(EmptyFilter)
        loadSm([], 0, 0);
        loadTeam([], 0, "");
        loadType();
        loadBranch();
        loadCompany();
        loadRecruiters([], 0, 0);
        loadSkillCategories();
        setselectedSm(null)
        setSelectedRecruiter(null)
        setSelectedBranch([])
    }

    return (
        // <Dialog visible={props.open} style={{ width: '80vw' }} header="Search Pipeline" modal className="p-fluid" onHide={onHide}>
        <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
            <JVDate maxDate={new Date} column={6} label="From Date" control={control} name="fromDate" />
            <JVDate maxDate={new Date} column={6} label="To Date" control={control} name="toDate" />
            {!((_roles.includes(3) || _roles.includes(4) || _roles.includes(21))) && <JVInput column={6} label="End Client" control={control} name="req_EndClient" />}
            {!((_roles.includes(3) || _roles.includes(4) || _roles.includes(34) || _roles.includes(40))) && <JVDropdownInput column={6} label="Prime Vendor" completeMethod={completeMethodEC} control={control} name="vendor_Company" options={clientCompanies} optionLabel="vendor_Company_Name" placeholder="Search Prime Vendor" />}
            <JVDropdownInput column={6} label="Sub Vendor" completeMethod={completeMethodSubVendor} control={control} name="subVendor" options={subVendorCompanies} optionLabel="vendor_Company_Name" placeholder="Search Sub Vendor" />
            <JVInput column={6} label="Req ID" type="number" control={control} name="req_ID" />

            <JVDropdown column={6} label="Type" control={control} name="companyType" options={type} optionLabel="type_Name" optionValue="type_Name" placeholder="Select Type" />
            <JVDropdown column={6} label="Company Name " control={control} name="company" options={company} optionLabel="company_Name" optionValue="company_ID" placeholder="Select Company Name" />
            {/* <JVDropdown column={6} label="Branch " control={control} name="branch" options={branch} optionLabel="branchName" optionValue="branch_ID" placeholder="Select Branch " /> */}
            <div className="field col-2 md:col-2">
                <p>Branch</p>
                <MultiSelect className="" style={{ height: "37px", marginTop: "-10px" }} value={selectedBranch} onChange={(e) => setSelectedBranch(e.value)} options={branch} optionValue="branch_ID" optionLabel="branchName" display="chip" filter placeholder="Select Branches" />
            </div>
            <JVDropdown column={6} label="Team" control={control} name="team" options={team} optionLabel="team_Name" optionValue="team_ID" placeholder="Select Team" />
            {/* /*<JVDropdown column={6} label="Sales Manager" control={control} name="sm" options={sm} optionLabel="user_Name" optionValue="login_ID" placeholder="Select Sales" /> */}
            {/* <JVDropdown column={6} label="Recruiter" control={control} name="recruiter_ID" options={recruiters} optionLabel="user_Name" optionValue="login_ID" placeholder="Select Recruiter" /> */}
            <JVDropdown column={6} label="Req Category" control={control} name="req_Category" options={skillCategories} optionLabel="req_CategoryName" optionValue="req_CategoryID" placeholder="Select Req Category" />
            <JVDropdown column={6} label="Status" control={control} name="status_Name" options={submissionStatus} optionLabel="status_Name" optionValue="status_Name" placeholder="Select Status" />
            <div style={{ width: '15%', marginLeft: '10px' }} >
                <label className="" style={{ display: 'block', marginBottom: '8px' }}>Sales Manager</label>
                <Dropdown value={selectedSm} onChange={(e) => {
                    console.log(e);
                    setselectedSm(e.value);
                    // loadSm(e.value?.Company,0,0);
                }} options={sm} optionLabel="user_Name" placeholder="Select Sales manager" optionValue="login_ID"
                    filter className="w-full" />

            </div>
            <div style={{ width: '15%', marginLeft: '10px' }} >
                <label className="" style={{ display: 'block', marginBottom: '8px' }}>Recruiter</label>
                <Dropdown value={selectedRecruiter} onChange={(e) => {
                    setSelectedRecruiter(e.value);
                }} options={recruiters} optionLabel="user_Name" placeholder="Select Recruiter" optionValue="login_ID"
                    filter className="w-full" />

            </div>
            <JVInput column={6} label="Consultant Name/Email" type="text" control={control} name="Consultant_Name" />
            <JVDropdown column={6} label="Latency Type" control={control} name="litency_Type" options={LitencyType} optionLabel="litency_Type" optionValue="litency_Type" placeholder="Select Litency" />
            <div style={{ margin: '10px 0', width: '100%' }}></div>
            <JVDropdown column={6} label="Client Type" control={control} name="client_Type" options={client_Type} optionLabel="clientTypeName" optionValue="id" placeholder="Select Client Type" />

            <div className="col-12 md:col-12" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', columnGap: '10px', marginTop: '10px' }}>
                <Button className="field col-12 md:col-6" label="SEARCH" type="submit"></Button>
                <Button className="field col-12 md:col-6 p-button-outlined" label="CLEAR" onClick={onClear} type="button"></Button>
            </div>
        </form>
    )
}
